import { createContext } from "react";

export const ContextPurchaseOrder = createContext(null);
